import React from 'react';
import styled from 'styled-components';
import ModalWrapper from '@material-ui/core/Modal';

const ModalBody = styled.div.attrs({
    className: 'modal-body'
}) `
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;

    & > .modal-close-button {
        cursor: pointer
        padding: 0.25em 0.5em;
        position: fixed;
        top: 30px;
        right: 30px;
        font-size: 2em;
        line-height: 1em;
    }

    & > .modal-body {
    }
`;

export class Modal extends React.Component {
    render() {
        const { children, closeButton, open, history, ...props } = this.props;
        
        if (!open) return (null);

        return (
            <ModalWrapper
                open={open}
                {...props}>
                <ModalBody>
                    {children}
                </ModalBody>
            </ModalWrapper>
        )
    }

}